import * as React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import { Switch, Route, useParams, useRouteMatch, useHistory, useLocation } from 'react-router-dom';
import {
    Grid,
    Paper,
    Typography,
    AppBar, Tabs, Tab
} from '@material-ui/core';

import { EntityDataAccessComponent } from './dataAccess/entity';
import { LayoutDataAccessComponent } from './dataAccess/layout';
import { TableDataAccessComponent } from './dataAccess/table';

import { usePreferences } from '../contexts';

interface DataAccessTab {
    name: string;
    label: string;
    path: string;
    element: JSX.Element;
}
const tabs: ReadonlyArray<DataAccessTab> = [
    {
        name: 'entity',
        label: 'Entity',
        path: '/entity/:entityKey?',
        element: <EntityDataAccessComponent />
    },
    {
        name: 'layout',
        label: 'Layout',
        path: '/layout/:layoutKey?',
        element: <LayoutDataAccessComponent />
    },
    {
        name: 'contract',
        label: 'Contract',
        path: '/contract/:contractKey?',
        element: <em>TODO</em>
    },
    {
        name: 'table',
        label: 'Table',
        path: '/table/:tableKey?',
        element: <TableDataAccessComponent />
    }
]

const styles = makeStyles((theme) => ({
    root: {
        // background: '#c6cacf'
    }
}));

export function DataAccess() {
    const classes = styles();

    const { artifact } = useParams<{ artifact?: string }>()
    const history = useHistory();
    const { path } = useRouteMatch();

    const [ preferences, setPreferences ] = usePreferences();

    React.useEffect(() => {
        if (!artifact && !!preferences.dataAccessTab) {
            history.replace(`/data-access/${preferences.dataAccessTab}`);
        }
    }, [ artifact, preferences ]);

    const onTabChange = (idx: number) => {
        setPreferences(prev => ({
            ...prev,
            dataAccessTab: tabs[idx].name
        }));

        history.push(`/data-access/${tabs[idx].name}`);
    }

    return (
        <Paper className={classes.root}>
            <AppBar position="static" square={false}>
                <Tabs value={tabs.findIndex(t => t.name === artifact)} onChange={(e, value) => onTabChange(value)}>
                    {tabs.map((tab, tabIndex) => <Tab label={tab.label} tabIndex={tabIndex} />)}
                </Tabs>
            </AppBar>

            <Switch>
                {tabs.map((tab) => (
                    <Route path={`${path}${tab.path}`}>
                        {tab.element}
                    </Route>
                ))}
            </Switch>
        </Paper>
    );
}